import angular from 'angular';

import {} from './od-story-card-mini.less';

module.exports = angular.module('market.components.od-story-card-mini', [
])
.component('odStoryCardMini', {
  template: require('./od-story-card-mini.jade')(),
  transclude: {
    title: 'odStoryCardMiniTitle',
    subtitle: 'odStoryCardMiniSubtitle',
    linkText: 'odStoryCardMiniLinkText',
  },
  bindings: {
    imageSrc: '@',
    href: '@'
  },
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-story-card-mini.js
 **/